import React, {useEffect, useState} from 'react';
import {withRouter, useLocation} from 'react-router-dom';
import {Layout, Spin, Alert, message} from 'antd';
import {Container} from 'reactstrap';
import {useAuth0} from "../../services/auth0";
import {roles} from "../../constants";

const {Content} = Layout;

const LoadingMiddleware = ({history}) => {
    const {user, getTokenSilently, getIdTokenClaims, loginWithRedirect, isAuthenticated} = useAuth0();
    const [loading, setPageLoader] = useState(true);
    const location = useLocation();

    useEffect(() => {
        if (!user) {
            setTimeout(storeAuthDetails, 2000)
        } else {
            storeAuthDetails()
        }
    });

    //refactor below function to use more hooks
    //explore using Auth0 cache location at initialization instead of manually setting the local storage access token

    const storeAuthDetails = async () => {
        const urlParams = new URLSearchParams(location.search)
        const params = urlParams.get('code')
        try {
            if (localStorage.accessToken) {
                history.push(localStorage.role === roles.ADMIN || localStorage.role === roles.TRANSLATOR ? '/user-requests' : '/dashboard');
                return;
            } else if (user) {
                const claims = await getIdTokenClaims();
                const role = claims['https://paradi.io/access'] || "user";
                localStorage.setItem('accessToken', await getTokenSilently());
                localStorage.setItem('role', role);
                history.push(role === roles.ADMIN || roles.TRANSLATOR ? '/user-requests' : '/dashboard');
                return;
            } else {
                if (!params) {
                    console.log('')
                    const returnLink = window.location.origin + '/app-loading';
                    await loginWithRedirect({redirect_uri: returnLink});
                }
                
            }
        } catch (e) {
            if (params) {
                message.error('failed to get data');
            }
            setPageLoader(false);
        }

    };

    return (
        <div className="loader">
            <img src={require('../../assets/images/loader.svg')} alt=""/>
        </div>
    )
};

export default withRouter(LoadingMiddleware);
